import React, { useState, useEffect } from "react";
import Toggle from "../../../generic/toggle";
import ObCheckbox from "./obCheckbox";
import EdButton from "../../../generic/edButton";
import DeviceContext from "../../../service/indentifyDevice";
import indexer from "../../../types/genericTypes";
import { Idevice } from "../../../types/device";
import { HOb2DGroupBy } from "../../../service/orderBook/obGrpByHelper";
import {
  ChipStatusComb,
  ChipStatusMfSipComb,
  openStatusArr,
  ChipStatusMfComb,
} from "./../obConstants";
import "../../../../assets/scss/components/generic/filter.scss";

export interface ObFilterProps {
  data: Array<Array<any>>; // data to be filtered
  onFilter: (filteredData: Array<any>) => void; // function to be called on clicking of checkbox
  filterInputParams: indexer;
  tglClick?: (toggle: boolean) => void;
}

interface ICheckboxState {
  value: string;
  isChecked: boolean;
}

const ObFilter: React.FC<ObFilterProps> = (props) => {
  //setting state initially as false
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isAllSelected, setIsAllSelected] = useState(true);

  const deviceState: Idevice = DeviceContext();
  let filterDropDownOption: Array<ICheckboxState>;

  switch (props.filterInputParams.aType) {
    case "mf":
      filterDropDownOption = [
        { value: "In Process", isChecked: true },
        { value: "Completed", isChecked: true },
        { value: "Rejected", isChecked: true },
        { value: "Cancelled", isChecked: true },
        { value: "AMO", isChecked: true },
      ];
      break;
    case "mfSip":
      filterDropDownOption = [
        { value: "Active", isChecked: true },
        { value: "Inactive", isChecked: true },
      ];
      break;
    case "pm":
      filterDropDownOption = [
        { value: "Open", isChecked: true },
        { value: "Completed", isChecked: true },
        { value: "Rejected", isChecked: true },
        { value: "Cancelled", isChecked: true },
      ];
      break;
    default:
      if (props.filterInputParams.isHistory) {
        filterDropDownOption = [
          { value: "Completed", isChecked: true },
          { value: "Rejected", isChecked: true },
          { value: "Cancelled", isChecked: true },
        ];
      } else {
        filterDropDownOption = [
          { value: "Open", isChecked: true },
          { value: "Completed", isChecked: true },
          { value: "Rejected", isChecked: true },
          { value: "Cancelled", isChecked: true },
          { value: "AMO", isChecked: true },
        ];
      }
      break;
  }
  // setting checkboxes values
  const [checkboxesState, setcheckboxesState] = useState(filterDropDownOption);

  //used to previous State value
  const prevCheckboxesStateRef: any = React.useRef();

  const prevCheckBoxState: Array<any> = prevCheckboxesStateRef.current;

  const [isToggleOn, setIsToggleOn] = useState(
    props.filterInputParams.showOpenOrderOnTop || false
  );

  //event to be performed on onChecked
  function onChecked(index: number) {
    const tempCheckboxesState = [...checkboxesState];

    const filteredData = groupData(props.data[0], isToggleOn);

    // if all orders checkbox is clicked
    if (index === -1) {
      !deviceState.isMobile &&
        props.onFilter(isAllSelected ? [[]] : filteredData);
      setIsAllSelected(!isAllSelected);
      setcheckboxesState(
        tempCheckboxesState.map((tempCheckboxState) => ({
          ...tempCheckboxState,
          isChecked: !isAllSelected,
        }))
      );
      return;
    }

    // if any other checkbox is clicked
    const currentCheckbox = { ...tempCheckboxesState[index] };

    currentCheckbox.isChecked = !checkboxesState[index].isChecked;
    tempCheckboxesState[index] = currentCheckbox;
    //set all selected flag if all the checkboxes are enabled
    setIsAllSelected(
      tempCheckboxesState.filter(
        (tempCheckboxState) => tempCheckboxState.isChecked
      ).length === tempCheckboxesState.length
    );
    if (
      !tempCheckboxesState.find(
        (tempCheckboxState) => tempCheckboxState.isChecked
      )
    ) {
      // if all checkboxes are not selected
      !deviceState.isMobile &&
        props.onFilter(!isAllSelected ? [[]] : filteredData);
    } else {
      // if any checkbox is selected
      !deviceState.isMobile &&
        props.onFilter(filterData(filteredData, tempCheckboxesState));
    }
    setcheckboxesState(tempCheckboxesState);
  }

  //event to be performed on onSwitchOnOff
  function onSwitchOnOff() {
    let filteredData;
    if (isToggleOn) {
      // now toggle is off
      filteredData = filterData(props.data, checkboxesState);
    } else {
      // now toggle is on
      // group the data
      filteredData = groupData(props.data[0], true);
      filteredData = !isAllSelected
        ? filterData(filteredData, checkboxesState)
        : filteredData;
    }

    props.onFilter(filteredData);
    props.tglClick && props.tglClick(!isToggleOn);

    setIsToggleOn(!isToggleOn);
  }

  /**
   * This function groups open/pending and other data separately
   * @param data array of data to be grouped
   */

  function groupData(data: Array<any>, isToggleOn: boolean): Array<Array<any>> {
    if (isToggleOn) {
      // if toggle is switched on, then group the data
      return HOb2DGroupBy(
        data,
        props.filterInputParams.status,
        props.filterInputParams.aType === "mf"
          ? ["accepted"]
          : props.filterInputParams.aType === "mfSip"
          ? ["running"]
          : openStatusArr
      );
    } else {
      // if toggle is switched off then return the initial data in 2D form
      return [data];
    }
  }

  function filterData(
    data: Array<Array<any>>,
    checkboxesState: Array<ICheckboxState>
  ): Array<Array<any>> {
    return data.map((group) => {
      const a = group.filter((d) => {
        if (!checkboxesState.find((checkboxState) => checkboxState.isChecked)) {
          // if all checkboxes are unchecked
          return false;
        }
        // else
        if (!isAllSelected) {
          return !!checkboxesState.find((checkbox) => {
            let checkBoxFilter: Boolean,
              statusObj: indexer = ChipStatusComb;
            switch (props.filterInputParams.aType) {
              case "mf":
                statusObj = ChipStatusMfComb;
                break;
              case "mfSip":
                statusObj = ChipStatusMfSipComb;
                break;
              default:
                //console.log("do nothing");
                break;
            }

            let stsval: string = statusObj[checkbox.value.toLowerCase()] || ""; //used to filter mf SIP's
            //mf's SIP with status running are of active SIP rest all are inactvie
            checkBoxFilter =
              stsval.indexOf("running") < 0 &&
              props.filterInputParams.aType !== "mfSip"
                ? d[props.filterInputParams.status] &&
                  statusObj[d[props.filterInputParams.status].toLowerCase()] &&
                  checkbox.value.toLowerCase() ===
                    statusObj[d[props.filterInputParams.status].toLowerCase()]
                : stsval.indexOf("not") < 0
                ? stsval === d[props.filterInputParams.status].toLowerCase()
                : stsval.replace("not ", "") !==
                  d[props.filterInputParams.status].toLowerCase();
            return (
              checkbox.isChecked &&
              (checkBoxFilter ||
                (d.ogt &&
                  checkbox.value.toLowerCase() === d.ogt.toLowerCase()) ||
                (d.ordStatus &&
                  d.ordStatus.toLowerCase() === checkbox.value.toLowerCase()))
            );
          });
        } else {
          return isAllSelected;
        }
      });
      return a;
    });
  }
  function applyFilter() {
    const filteredData = groupData(props.data[0], isToggleOn);
    props.onFilter(filterData(filteredData, checkboxesState));
    setIsDropdownOpen(false);
  }
  function reset() {
    //ob mobile filters will be applied on clicking apply filter, else it will be restored to prev State
    if (deviceState.isMobile) {
      setcheckboxesState(prevCheckBoxState);
      prevCheckBoxState.filter((s) => s.isChecked).length ===
      checkboxesState.length
        ? setIsAllSelected(true)
        : setIsAllSelected(false);
    }
    setIsDropdownOpen(false);
  }

  useEffect(() => {
    prevCheckboxesStateRef.current = checkboxesState;
  }, [props.data]);

  useEffect(() => {
    setIsToggleOn(props.filterInputParams.showOpenOrderOnTop);
  }, [props.filterInputParams.showOpenOrderOnTop]);

  return (
    <div
      className={
        " filter " +
        (!isAllSelected ? " active" : "") +
        (!deviceState.isMobile ? " navigation_dropdown" : "")
      }
    >
      {/* dropdown toggle on click of button */}
      <EdButton
        value={
          <>
            <i className="filter edel-icon-filter btn_icon" />
            {!deviceState.isMobile && <span className="fltr_lbl">Filter</span>}
          </>
        }
        btnTyp="blue-link"
        onClick={() => setIsDropdownOpen(true)}
      />

      {/* if isDropdownOpen is true the the dropdown will show */}
      {isDropdownOpen && (
        <>
          <div className="dropdown_overlay" onClick={() => reset()} />
          <ul className="dropdown_content">
            {/* toggle the radio button */}
            {(!props.filterInputParams ||
              props.filterInputParams.showOpenOrderTgl !== false ||
              props.filterInputParams.showOpenOrderTgl === true) && (
              <>
                <li className="dropdown_item">
                  <Toggle
                    name="toggle1"
                    isOn={isToggleOn}
                    onChange={onSwitchOnOff}
                  >
                    {props.filterInputParams.aType === "mf"
                      ? "Accepted orders on top"
                      : props.filterInputParams.aType === "mfSip"
                      ? "Active orders on top"
                      : "Open orders on top"}
                  </Toggle>
                </li>
                <hr className="slim_line" />
              </>
            )}
            <div className="ObddOpts">
              <li className="dropdown_item">
                <ObCheckbox
                  name="chkbox-filter"
                  checked={isAllSelected}
                  onChange={(e) => onChecked(-1)}
                >
                  All Orders
                </ObCheckbox>
              </li>
              {/* checkboxes check /uncheck */}
              {checkboxesState.map((checkbox, index) => (
                <li className="dropdown_item" key={index}>
                  <ObCheckbox
                    name="chkbox-filter"
                    checked={checkbox.isChecked}
                    onChange={(e) => onChecked(index)}
                    disabled={isAllSelected}
                  >
                    {checkbox.value}
                  </ObCheckbox>
                </li>
              ))}
            </div>
            {deviceState.isMobile && (
              <div className="fltr_btn">
                <EdButton
                  value="Close"
                  btnTyp="secondary"
                  className="mob_fltr"
                  onClick={() => reset()}
                />
                <EdButton
                  value=" Apply Filter"
                  btnTyp="primary"
                  className="mob_fltr"
                  onClick={applyFilter}
                />
              </div>
            )}
          </ul>
        </>
      )}
    </div>
  );
};
export default ObFilter;
